import {ApiResidentPermissions} from "../constants/ApiPermissions";
import RulesetBase from "./rulesetBase";

/**
 * Ruleset for resident admin
 *
 * @class
 * @extends {RulesetBase}
 */
class ResidentAdminRuleset extends RulesetBase {
  defineRules = (userPermissions: string[]): void => {
    const {can} = this.abilityBuilder;
    let onlyRead = false;

    for (let permission of userPermissions) {
      if (
        permission.toUpperCase() ===
        ApiResidentPermissions.readWrite.toUpperCase()
      ) {
        can("Create", "ResidentAdmin");
        can("Delete", "ResidentAdmin");
        can("Update", "ResidentAdmin");
        can("Read", "ResidentAdmin");
        onlyRead = false;
        break;
      } else if (
        permission.toUpperCase() === ApiResidentPermissions.read.toUpperCase()
      ) {
        onlyRead = true;
      }
    }
    if (onlyRead) {
      can("Read", "ResidentAdmin");
    }
  };
}

export default ResidentAdminRuleset;
